import React, { useState, createContext, useContext } from 'react';
type VideoContextType = {
  isOpen: boolean;
  videoId: string | null;
  videoTitle: string;
  openVideo: (id: string, title: string) => void;
  closeVideo: () => void;
};
const VideoContext = createContext<VideoContextType | undefined>(undefined);
export const VideoProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [videoId, setVideoId] = useState<string | null>(null);
  const [videoTitle, setVideoTitle] = useState('');
  const openVideo = (id: string, title: string) => {
    setVideoId(id);
    setVideoTitle(title);
    setIsOpen(true);
    document.body.style.overflow = 'hidden';
  };
  const closeVideo = () => {
    setIsOpen(false);
    document.body.style.overflow = 'auto';
  };
  return <VideoContext.Provider value={{
    isOpen,
    videoId,
    videoTitle,
    openVideo,
    closeVideo
  }} data-id="element-331">
      {children}
      {isOpen && <VideoModal data-id="element-332" />}
    </VideoContext.Provider>;
};
export const useVideo = () => {
  const context = useContext(VideoContext);
  if (context === undefined) {
    throw new Error('useVideo must be used within a VideoProvider');
  }
  return context;
};
const VideoModal = () => {
  const {
    videoId,
    videoTitle,
    closeVideo
  } = useVideo();
  if (!videoId) return null;
  return <div className="fixed inset-0 bg-black/90 backdrop-blur-sm z-[100] flex items-center justify-center p-4 md:p-8" data-id="element-333">
      <div className="absolute inset-0" onClick={closeVideo} data-id="element-334"></div>
      <div className="relative z-10 w-full max-w-5xl bg-gray-900 rounded-sm overflow-hidden" data-id="element-335">
        <div className="flex justify-between items-center p-4 border-b border-gray-800" data-id="element-336">
          <h3 className="text-xl font-semibold text-white" data-id="element-337">{videoTitle}</h3>
          <button onClick={closeVideo} className="text-gray-400 hover:text-white" data-id="element-338">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-339">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-340" />
            </svg>
          </button>
        </div>
        <div className="aspect-video w-full" data-id="element-341">
          <iframe width="100%" height="100%" src={`https://www.youtube.com/embed/${videoId}?autoplay=1`} title={videoTitle} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="w-full h-full" data-id="element-342"></iframe>
        </div>
      </div>
    </div>;
};